// extracted by mini-css-extract-plugin
export default {"eventPage":"NoEvent_eventPage__wWldC"};